/** Max characters for Research Context / Interview Guide fields (UI + API). */
export const RESEARCH_CONTEXT_MAX_CHARS = 30_000;

/** Soft budget for Context / Guide Builder generation (server enforces the same). */
export const RESEARCH_CONTEXT_GENERATION_MAX_CHARS = 28_000;
